module.exports = __webpack_public_path__ + "static/1-baadf49056dd5e26c5863cd647f314fa.jpg";